<template>
  <div id="container" :style="{height:mapHeight +'px'}"></div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "ShowMap",
    data() {
      return {
        // center: {lng: 109.45744048529967, lat: 36.49771311230842},
        myChart:null,
        dbData:[],
        bmap:null,
        mapHeight:550
      }
    },
    computed: {
      ...mapState('main', ['tableHeight'])
    },
    methods: {

      initMap(){
        var dom = document.getElementById("container");
        this.myChart = window.echarts.init(dom);

        var option=null;
        var option1=null;
        var startPoint = {
          x: 79.114129,
          y: 25.550339
        };
        // 地图
        this.bmap = {
          center: [startPoint.x, startPoint.y],
          zoom: 3,
          roam: true,
          mapStyleV2: {
            //设置地图自定义样式
            styleId: "1c9508432f1bd060b4485d79045d5bdd",
          },
        }

        this.initData();



      },
      loadMapData(){
        //飞线图标
        var planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
        var option=null;
        var dataArray = [];
        for(let i=0;i<this.dbData.length;i++){
          let obj = this.dbData[i];
          if(obj.services_scope && obj.services_scope.length>0){
            for(let j=0;j<obj.services_scope.length;j++){
              let areaObj = obj.services_scope[j];
              let data = {
                fromName: areaObj.name,
                toName: obj.id,
                coords:[[areaObj.lat, areaObj.lng],[obj.lat,obj.lng]]
              }
              dataArray.push(data);
            }

          }

        }
        var series = [
          //飞线数据
          {
            //name: 'wha Top1',
            type: 'lines',
            coordinateSystem: 'bmap',
            zlevel: 2,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: planePath,
              symbolSize: 15
            },
            lineStyle: {
              normal: {
                color: '#FF3030',
                width: 2,
                opacity: 0.4,
                curveness: 0.2
              }
            },
            data: dataArray
          }
        ];

        option = {
          bmap: this.bmap,
          tooltip: {
            trigger: 'item'
          },
          series: series
        };
        this.myChart.setOption(option);

      },
      initData(){
        this.$axios.get(this.baseUrl3 + 'instance/getServiceScope')
          .then(({ data: { msg, data, code } }) => {
            if (code == 20000) {
              this.dbData = data;
              this.loadMapData();
            } else {
              this.$message({ showClose: true, message: msg, type: 'error' })
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    mounted() {
      this.initMap();
      this.mapHeight = this.tableHeight+40;
    },
  }
</script>

<style scoped>

</style>
